import { View } from '@olxbr/design-system'
import React from 'react'

const Separator = ({ turns, style }) => (
  <View
    style={{
      position: 'absolute',
      height: '100%',
      transform: `rotate(${turns}turn)`,
    }}
  >
    <View style={style} />
  </View>
)

const RadialProgressSeparator = ({ count, style }) => {
  const turns = 1 / count
  const separators = []

  // eslint-disable-next-line no-plusplus
  for (let i = 1; i <= count; i++) {
    separators.push(<Separator key={i} turns={i * turns} style={style} />)
  }

  return separators
}

export default RadialProgressSeparator
